var _templateObject, _templateObject2;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { TextCallout1, IconWarning, IconIllustrativeVerifiedWhite, colors } from '@blocket/blocket-ui';
import trackVerificationFeedback from './trackingFunc';
import { sessionStorageGetItem, sessionStorageRemoveItem } from '../../../utils/useSessionStorage';
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 75px;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  z-index: 10000; //looks like the highest number in adout is 9000\n  top: 24px;\n  left: 50%;\n  transform: translate(-50%, -0%);\n  white-space: nowrap;\n"])), function (props) {
  return props.verified ? colors.green400 : colors.yellow900;
});
var Text = styled(TextCallout1)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-left: 8px;\n"])), colors.white100);

var AccountVerificationFeedback = function AccountVerificationFeedback(_ref) {
  var accountVerified = _ref.accountVerified,
      pulseEvent = _ref.pulseEvent,
      _ref$hideAfterSeconds = _ref.hideAfterSeconds,
      hideAfterSeconds = _ref$hideAfterSeconds === void 0 ? 10 : _ref$hideAfterSeconds;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showVerificationFeedback = _useState2[0],
      setShowVerificationFeedback = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      actionsOnMountDone = _useState4[0],
      setActionsOnMountDone = _useState4[1];

  useEffect(function () {
    var bankIdAccountVerificationStarted = sessionStorageGetItem('StartBankIdAccountVerification');
    var timer;

    if (bankIdAccountVerificationStarted) {
      setShowVerificationFeedback(true);
      var value = hideAfterSeconds * 1000; // millisec

      timer = setTimeout(setShowVerificationFeedback, value, false);
    }

    return function () {
      clearTimeout(timer);
    };
  }, []);
  useEffect(function () {
    if (showVerificationFeedback && !actionsOnMountDone) {
      if (pulseEvent) {
        trackVerificationFeedback(pulseEvent, accountVerified);
      }

      sessionStorageRemoveItem('StartBankIdAccountVerification');
      setActionsOnMountDone(true);
    }
  }, [actionsOnMountDone, showVerificationFeedback]);

  if (!showVerificationFeedback) {
    return null;
  }

  var text = accountVerified ? 'Tack för att du bidrar till ett tryggare Blocket!' : 'Verifieringen gick inte igenom';
  var icon = accountVerified ? /*#__PURE__*/React.createElement(IconIllustrativeVerifiedWhite, {
    width: "24",
    height: "24"
  }) : /*#__PURE__*/React.createElement(IconWarning, {
    color: colors.white100,
    width: "24",
    height: "24"
  });
  return /*#__PURE__*/React.createElement(Wrapper, {
    verified: accountVerified
  }, icon, /*#__PURE__*/React.createElement(Text, null, text));
};

AccountVerificationFeedback.propTypes = {
  accountVerified: PropTypes.bool.isRequired,
  pulseEvent: PropTypes.func,
  hideAfterSeconds: PropTypes.number
};
export default AccountVerificationFeedback;
//# sourceMappingURL=AccountVerificationFeedback.js.map